<template>
  <div>
    <button class="invite-single-learner" @click="modals.showInviteLearnerModal = true">
      <i class="el-icon-circle-plus-outline" />
      {{
        isOrgUseDummyEmail
          ? $t("student.generate_dummy_learners")
          : $t($i18nLabelsHelper(currentOrganizationType, "students_page.invite"))
      }}
    </button>
    <invite-learners
      :dialogVisible="modals.showInviteLearnerModal && !inviteMultipleMode"
      :inviteMultipleMode.sync="inviteMultipleMode"
      :organizationId="currentOrganizationId"
      :isOrganizationUseDummyEmail="isOrgUseDummyEmail"
      v-on:closed="modals.showInviteLearnerModal = false"
      v-on:update-pending="getPendingPage"
    />
    <invite-multiple-learners
      :dialogVisible="modals.showInviteLearnerModal && inviteMultipleMode"
      :inviteMultipleMode.sync="inviteMultipleMode"
      :organizationId="currentOrganizationId"
      :organizationType="currentOrganizationType"
      :shouldShowInviteAll="true"
      :isOrganizationUseDummyEmail="isOrgUseDummyEmail"
      v-on:closed="modals.showInviteLearnerModal = false"
      v-on:update-pending="getPendingPage"
      v-on:on-invited="handleOnInvited"
    />
    <add-learners
      :dialogVisible="modals.showAddLearnerToTeamModal"
      v-on:closed="modals.showAddLearnerToTeamModal = false"
      v-on:update-learner="getStudentPage"
    />
  </div>
</template>

<script>
import InviteLearners from "@/components/modals/organizations/InviteLearners";
import InviteMultipleLearners from "@/components/modals/organizations/InviteMultipleLearners";
import AddLearners from "@/components/modals/organizations/AddLearnerToTeam";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    InviteLearners,
    InviteMultipleLearners,
    AddLearners,
  },
  props: {
    isOrganizationUseDummyEmail: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      modals: {
        showInviteLearnerModal: false,
        showAddLearnerToTeamModal: false,
        showRemoveAccountModal: false,
        showEditLearnerModal: false,
        showViewCredentialModal: false,
      },
      inviteMultipleMode: false,
    };
  },
  computed: {
    ...mapGetters("organization", ["currentOrganizationId", "currentOrganizationType"]),
    isOrgUseDummyEmail() {
      if (this.isOrganizationUseDummyEmail === undefined) {
        return this.$store.getters["organization/isOrganizationUseDummyEmail"];
      } else {
        return this.isOrganizationUseDummyEmail;
      }
    },
  },
  methods: {
    ...mapActions("organization", ["getPendingInviteStudents"]),
    ...mapActions("students", ["getStudents"]),

    getPendingPage() {
      this.getPendingInviteStudents();
    },
    handleOnInvited() {
      this.$emit("on-invited");
    },
    getStudentPage() {
      this.getStudents();
    },
  },
};
</script>

<style lang="scss" scoped>
.invite-single-learner {
  background: #007eff;
  border-radius: 8px;
  border: none;
  height: 48px;
  color: white;
  padding: 11px;
  font-size: 18px;
  width: auto;
  cursor: pointer;
  white-space: nowrap;
  // margin: 0 10px;
  &:hover {
    background: #0362c4;
  }
}
</style>
